var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ItemBase } from '../../../models/item/item-base';
var RangeOperatorComponent = /** @class */ (function (_super) {
    __extends(RangeOperatorComponent, _super);
    function RangeOperatorComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.radioDisp = true;
        _this.cols = [];
        return _this;
    }
    RangeOperatorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        var type = this.col.controlType.replace(/Operator$/, '');
        var rangeCol = JSOG.parse(JSON.stringify(this.col));
        var rangeFromParams = jsonpath.value(rangeCol, '$.params.rangeFrom');
        var rangeToParams = jsonpath.value(rangeCol, '$.params.rangeTo');
        if (rangeFromParams) {
            delete rangeCol.params.rangeFrom;
        }
        if (rangeToParams) {
            delete rangeCol.params.rangeTo;
        }
        rangeFromParams = $.extend(true, {}, rangeCol.params, rangeFromParams);
        rangeToParams = $.extend(true, {}, rangeCol.params, rangeToParams);
        if (type === 'datetime') {
            $.extend(true, rangeToParams, { options: { defaultHour: 23, defaultMinute: 59 } });
        }
        this.cols = [];
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$operator.$radio.' + this.col.key,
            controlType: 'radio',
            required: true,
            params: {
                options: [
                    { code: 'match', display: this.msg['RangeOperatorComponent.radio.match'] },
                    { code: 'range', display: this.msg['RangeOperatorComponent.radio.range'] }
                ]
            }
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$match.' + this.col.key,
            controlType: type,
            params: this.col.params
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$rangeFrom.' + this.col.key,
            controlType: type,
            params: rangeFromParams
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$operator.$rangeFrom.' + this.col.key,
            controlType: 'select',
            required: true,
            params: {
                options: [
                    {
                        code: 'ge',
                        display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.ge']
                    },
                    {
                        code: 'gt',
                        display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.gt']
                    }
                ]
            }
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$rangeTo.' + this.col.key,
            controlType: type,
            params: rangeToParams
        }));
        this.cols.push(Object.assign(new ItemBase(), {
            key: '$operator.$rangeTo.' + this.col.key,
            controlType: 'select',
            required: true,
            params: {
                options: [
                    {
                        code: 'le',
                        display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.le']
                    },
                    {
                        code: 'lt',
                        display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.lt']
                    }
                ]
            }
        }));
        var operator = (this.col.params && this.col.params.operator ? this.col.params.operator : {});
        if (Object.keys(operator).length > 0) {
            var radioVal = '';
            if (typeof operator.range !== 'undefined' && operator.range === false) {
                this.radioDisp = false;
                radioVal = 'match';
            }
            else if (typeof operator.match !== 'undefined' && operator.match === false) {
                this.radioDisp = false;
                radioVal = 'range';
            }
            else if (operator.value) {
                radioVal = operator.value;
            }
            if (radioVal) {
                this.changeVal.emit({ key: '$operator.$radio.' + this.col.key, val: radioVal });
            }
            if (operator.rangeFrom && (operator.rangeFrom.readonly || operator.rangeFrom.hidden)) {
                this.changeVal.emit({ key: '$operator.$rangeFrom.' + this.col.key, val: operator.rangeFrom.value });
            }
            if (operator.rangeTo && (operator.rangeTo.readonly || operator.rangeTo.hidden)) {
                this.changeVal.emit({ key: '$operator.$rangeTo.' + this.col.key, val: operator.rangeTo.value });
            }
        }
    };
    RangeOperatorComponent.prototype.onChangeVal = function (e) {
        if (e.key === '$operator.$radio.' + this.col.key) {
            if (e.val === 'match') {
                this.changeVal.emit({ key: '$operator.$match.' + this.col.key, val: 'eq' });
                this.changeVal.emit({ key: '$rangeFrom.' + this.col.key, val: null });
                this.changeVal.emit({ key: '$operator.$rangeFrom.' + this.col.key, val: null });
                this.changeVal.emit({ key: '$rangeTo.' + this.col.key, val: null });
                this.changeVal.emit({ key: '$operator.$rangeTo.' + this.col.key, val: null });
            }
            else {
                this.changeVal.emit({ key: '$match.' + this.col.key, val: null });
                this.changeVal.emit({ key: '$operator.$match.' + this.col.key, val: null });
                this.changeVal.emit({ key: '$operator.$rangeFrom.' + this.col.key, val: 'ge' });
                this.changeVal.emit({ key: '$operator.$rangeTo.' + this.col.key, val: 'le' });
            }
        }
        this.changeVal.emit(e);
    };
    RangeOperatorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-range-operator',
                    template: "<ul *ngIf=\"cols.length > 0\">\n  <li *ngIf=\"radioDisp\" class=\"form_li\">\n    <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[0]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n  </li>\n  <ng-template [ngIf]=\"val['$operator.$radio.' + col.key] === 'match'\" [ngIfElse]=\"elseBlock\">\n    <li [key]=\"key\" [col]=\"col\" [val]=\"val\" columnDir>\n      <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[1]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n    </li>\n  </ng-template>\n  <ng-template #elseBlock>\n    <li [key]=\"key\" [col]=\"col\" [val]=\"val\" columnDir>\n      <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[2]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n    </li>\n    <li *ngIf=\"!col.params?.operator?.rangeFrom?.readonly && !col.params?.operator?.rangeFrom?.hidden\" class=\"form_li\">\n      <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[3]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n    </li>\n    <li *ngIf=\"col.params?.operator?.rangeFrom?.readonly\" class=\"form_li\">\n      <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[3]\" [val]=\"val['$operator.$rangeFrom.' + col.key]\" [msg]=\"msg\"></column-formlabel>\n    </li>\n    <li class=\"form_li\">~</li>\n    <li [key]=\"key\" [col]=\"col\" [val]=\"val\" columnDir>\n      <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[4]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n    </li>\n    <li *ngIf=\"!col.params?.operator?.rangeTo?.readonly && !col.params?.operator?.rangeTo?.hidden\" class=\"form_li\">\n      <columngroup [key]=\"key\" [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[5]\" [val]=\"val\" [msg]=\"msg\" (changeVal)=\"onChangeVal($event)\"></columngroup>\n    </li>\n    <li *ngIf=\"col.params?.operator?.rangeTo?.readonly\" class=\"form_li\">\n      <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"cols[5]\" [val]=\"val['$operator.$rangeTo.' + col.key]\" [msg]=\"msg\"></column-formlabel>\n    </li>\n  </ng-template>\n</ul>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    RangeOperatorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return RangeOperatorComponent;
}(ColumnBaseComponent));
export { RangeOperatorComponent };
//# sourceMappingURL=range-operator.component.js.map